import { type UnreadMessages } from 'models';
import { nodeApiClient, type NodeApiClientResponse, routes } from 'common/services';
import { type UnreadMessagesDataObject } from 'models/service';

export const getChatroomStats = async () =>
  nodeApiClient.get<UnreadMessagesDataObject, NodeApiClientResponse<UnreadMessages>>(routes.chatrooms.stats);
